export default __webpack_public_path__ + "static/media/6.552fa022.png";